import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, LogOut, User, Heart } from 'lucide-react';

const Navbar = ({ isAuthenticated, user, onLogout }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav
      className="shadow-lg sticky top-0 z-50"
      style={{
        background: 'linear-gradient(90deg, rgb(20, 184, 166) 0%, rgb(13, 148, 136) 50%, rgb(37, 99, 235) 100%)'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link
              to={isAuthenticated ? "/dashboard" : "/"}
              className="flex items-center h-14"
            >
              <img
                src="/logowhite.png"
                alt="MultiSellerPro"
                className="h-14 w-auto object-contain"
              /><span className='text-white -ml-1.5 -mt-3'>™</span>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            {!isAuthenticated ? (
              <>
                <Link
                  to="/"
                  className={`px-3 py-2 font-medium transition ${isActive('/') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Home
                </Link>
                <Link
                  to="/pricing"
                  className={`px-3 py-2 font-medium transition ${isActive('/pricing') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Pricing
                </Link>
                <Link
                  to="/login"
                  className={`px-3 py-2 font-medium transition ${isActive('/login') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="bg-white text-teal-600 px-6 py-2 rounded-lg hover:bg-gray-100 font-bold transition transform hover:scale-105"
                >
                  Sign Up
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/"
                  className={`px-3 py-2 font-medium transition ${isActive('/') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Home
                </Link>
                <Link
                  to="/how-i-use-msp"
                  className={`msp-cat-parent px-3 py-2 font-medium transition ${isActive('/how-i-use-msp') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  How I Use MSP
                  <style>{`
                          .msp-cat-parent { position: relative; overflow: hidden; }
                          .msp-cat-parent .msp-cat {
                              position: absolute;
                              bottom: 0;
                              right: 6px;
                              height: 20px;
                              width: auto;
                              transform: translateY(100%);
                              transition: transform 0.5s ease-out;
                              pointer-events: none;
                          }
                          .msp-cat-parent:hover .msp-cat {
                              transform: translateY(33%);
                          }
                  `}</style>
                  <img src="/cat.png" alt="Cat" className="msp-cat" />
                </Link>
                <div className="relative group">
                  <Link
                    to="/dashboard"
                    className={`px-3 py-2 font-medium transition ${isActive('/dashboard') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                      }`}
                  >
                    Dashboard ▾
                  </Link>
                  <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">
                    <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-1 w-48">
                      <Link
                        to="/dashboard"
                        state={{ tab: 'seller' }}
                        onClick={() => localStorage.setItem('preferredTool', 'seller')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700"
                      >
                        Seller Pro
                      </Link>
                      <Link
                        to="/dashboard"
                        state={{ tab: 'influencer' }}
                        onClick={() => localStorage.setItem('preferredTool', 'influencer')}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700"
                      >
                        Influencer Pro
                      </Link>
                    </div>
                  </div>
                </div>
                <Link
                  to="/msp-inventory"
                  className={`px-3 py-2 font-medium transition ${isActive('/msp-inventory') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Inventory
                </Link>
                <Link
                  to="/pricing"
                  className={`px-3 py-2 flex items-center gap-1 font-medium transition ${isActive('/pricing') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  Pricing
                </Link>
                <Link to="/favorites" className={`px-3 py-2 flex items-center gap-1 font-medium transition ${isActive('/favorites') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                  }`}>
                  <Heart size={20} />
                  Favs
                </Link>
                <Link
                  to="/settings"
                  className={`py-2 flex items-center gap-1 font-medium transition ${isActive('/settings') ? 'text-white font-bold' : 'text-white text-opacity-90 hover:text-white'
                    }`}
                >
                  <User size={16} />
                  <div className='flex items-center text-sm text-white'>
                    {user?.name || user?.email}
                  </div>
                </Link>
                <button
                  onClick={onLogout}
                  className="text-white hover:text-red-200 px-3 py-2 flex items-center gap-1 font-medium transition"
                >
                  <LogOut size={16} /> Logout
                </button>
              </>
            )}
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white">
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            {!isAuthenticated ? (
              <>
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/pricing"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Pricing
                </Link>
                <Link
                  to="/login"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left bg-white text-teal-600 px-3 py-2 rounded font-bold"
                >
                  Sign Up
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/how-i-use-msp"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  How I Use MSP
                </Link>
                <Link
                  to="/dashboard"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Dashboard
                </Link>
                <Link
                  to="/msp-inventory"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Inventory
                </Link>
                <Link
                  to="/pricing"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Pricing
                </Link>
                <Link
                  to="/settings"
                  onClick={() => setMobileMenuOpen(false)}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium flex items-center gap-1"
                >
                  <User size={16} /> {user?.name || user?.email}
                </Link>
                <button
                  onClick={() => { onLogout(); setMobileMenuOpen(false); }}
                  className="block w-full text-left text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded font-medium"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;